import { Card, Typography, useTheme } from '@mui/material';
import { MeasureFormat } from 'components/measure-unit/MeasureFormat';
import { FormattedMessage } from 'react-intl';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { tbColors } from 'styles/colors';

export function PseudoMeasureCard({
  titleId,
  additionalTitleId = '',
  percentage,
}: {
  titleId: string;
  additionalTitleId?: string;
  percentage: number;
}) {
  const theme = useTheme();

  const calcColour = () => {
    if (percentage === 0) {
      return '#1a1a1a';
    }
    return percentage > 0 ? tbColors.semantic.laurel['600'] : tbColors.semantic.coral['500'];
  };

  return (
    <Card
      className={`bg-snow-50 transition-all duration-200`}
      sx={{
        // We currently still have to inject our own elevation theme until
        // this component has been styled in TB.Desy
        cursor: 'default',
        transitionDuration: theme.transitions.duration.standard,
        borderBottom: `4px solid transparent`,
        boxShadow: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        textAlign: 'left',
        paddingTop: 5,
        paddingBottom: 4,
        paddingX: 5,
        gap: 3,
        height: '100%',
        borderRadius: '8px',
      }}
    >
      <Typography variant="h4" sx={{ minHeight: '2.25rem', height: '100%', fontWeight: 700 }}>
        <div>
          <span>
            <FormattedMessage id={titleId} />
          </span>
          {additionalTitleId && (
            <span className="text-xs font-normal text-text-secondary text-nowrap pl-2">
              <FormattedMessage id={additionalTitleId} defaultMessage="" />
            </span>
          )}
        </div>
      </Typography>
      <div className="space-y-1 flex flex-col justify-end h-full">
        <div className="flex items-center space-x-2">
          <Typography variant="h1" style={{ color: calcColour() }}>
            <MeasureFormat value={percentage} unit={MeasureUnitCode.PERCENT} config={{ hasSign: true }} />
          </Typography>
        </div>
        <div className="h-6" />
      </div>
    </Card>
  );
}
